import React, { type ReactElement, useEffect, useState } from 'react';

import { Typography } from '../DesignSystem';

import './SidebarToolTip.scss';

interface SidebarToolTipProps {
    children: ReactElement;
    tag: string;
    title: string;
    copy: string;
    dismissed?: boolean;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    hide: boolean;
}
const SidebarToolTip = ({
    children,
    tag,
    title,
    copy,
    dismissed = false,
    onClick,
    hide = false,
}: SidebarToolTipProps) => {
    const [tooltipClass, setTooltipClass] = useState<string>('sidebar-tooltip__body');
    useEffect(() => {
        setTooltipClass(hide ? 'sidebar-tooltip__body--hidden' : 'sidebar-tooltip__body');
    }, [hide]);

    if (dismissed) {
        return children;
    }

    return (
        <div className="sidebar-tooltip" onClick={onClick}>
            {children}
            <div className={tooltipClass}>
                <div className="sidebar-tooltip__arrow sidebar-tooltip__arrow-left" />
                <div className="sidebar-tooltip__canvas">
                    <Typography type="label" size={10} classes={['sidebar-tooltip__tag']}>
                        {tag}
                    </Typography>
                    <Typography type="label" size={20} classes={['sidebar-tooltip__headline']}>
                        {title}
                    </Typography>
                    <Typography type="paragraph" size={12} classes={['sidebar-tooltip__text']}>
                        {copy}
                    </Typography>
                </div>
                <div className="sidebar-tooltip__arrow sidebar-tooltip__arrow-down" />
            </div>
        </div>
    );
};

export default SidebarToolTip;
